import type { LfaServicesV2FieldsFragment } from '~/graphql/types';

type AccountService = LfaServicesV2FieldsFragment['accountServices'][number];
type Location = AccountService['locations'][number];
type CalendarRef = AccountService['calendars'][number];

export const locationsEqual = (
  a: Array<Location>,
  b: Array<Location>,
): boolean => {
  if (a.length !== b.length) return false;
  const bMap = new Map(b.map(l => [l.type, l]));
  return a.every(loc => {
    const other = bMap.get(loc.type);
    if (!other) return false;
    return (
      loc.weight === other.weight && (loc.note ?? '') === (other.note ?? '')
    );
  });
};

export const calendarRefsEqual = (
  a: Array<CalendarRef>,
  b: Array<CalendarRef>,
): boolean => {
  if (a.length !== b.length) return false;
  const bMap = new Map(b.map(c => [c.calendarId, c]));
  return a.every(ref => {
    const other = bMap.get(ref.calendarId);
    if (!other) return false;
    return (
      ref.weight === other.weight && (ref.note ?? '') === (other.note ?? '')
    );
  });
};
